<template>
  <div class="modal">
    <div class="modal-content">
      <div class="header">
        <h1>Order from {{ orderDetails.userLocation }}</h1>
        <h3>
          Order Time: {{ months[monthIndex] }} {{ date }} {{ hour }}:{{
            minute
          }}
          {{ ampm }}
        </h3>
      </div>
      <div class="order">
        <OrderSummaryItemView
          v-for="(food, index) in orderDetails.foodItems"
          :key="food"
          :itemName="food"
          :itemQuantity="orderDetails.foodItemsQuantity[index]"
        />
        <h6>Additional Requests:</h6>
        <p>{{ orderDetails.additionalRequests }}</p>
        <!--
        <table border="1px">
          <thead>
            <tr>
              <th class="tg-0lax">No.</th>
              <th>Food</th>
              <th>Quantity</th>
              <th class="tg-0lax">Remark</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(food, index) in orderDetails.foodItems" :key="food">
              <td>{{ index + 1 }}</td>
              <td>{{ food }}</td>
              <td>{{ orderDetails.foodItemsQuantity[index] }}</td>
            
            <td>{{ orderDetails.foodItemsRemarks[index] }}</td>
       
              <td>-</td>
            </tr>
          </tbody>
        </table>
        -->
      </div>

      <div class="selection">
        <button class="close-button" @click="closeModal">Close</button>
        <button class="accept-button" @click="acceptOrder()">
          Accept Order
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OrderSummaryItemView from "./OrderSummaryItemView.vue";

export default {
  name: "OrderModal",
  components: { OrderSummaryItemView },
  props: ["orderDetails"],
  data() {
    return {
      date: this.orderDetails.orderTime.toDate().getDate(),
      monthIndex: this.orderDetails.orderTime.toDate().getMonth(),
      hour: this.orderDetails.orderTime.toDate().getHours(),
      minute: this.orderDetails.orderTime.toDate().getMinutes(),
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      ampm: this.setampm(this.hour),
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-order-modal");
    },
    acceptOrder() {
      if (this.$store.state.profileId === this.orderDetails.userid) {
        this.$emit("accepting-own-order");
        console.log("Cannot Accept Your Own Order!");
        return;
      }
      this.$router.push({
        name: "ConfirmAndAccept",
        params: {
          orderDetails: this.orderDetails,
          orderId: this.orderDetails.orderId,
        },
      });
    },
    setampm(hours) {
      if (hours < 12) {
        return "AM";
      }
      return "PM";
    },
    formatTime() {
      this.hour = this.hour < 10 ? "0" + this.hour : this.hour;
      this.minute = this.minute < 10 ? "0" + this.minute : this.minute;
    },
  },
  created() {
    this.formatTime();
  },
  computed: {
    orderDetailsRemarks() {
      if (this.orderDetails.foodItemsRemarks) {
        return this.orderDetails.foodItemsRemarks;
      }
      return "defaultRemark";
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;
  position: fixed;

  width: 100%;
  height: 100%;
  align-self: center;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
  //padding: 0 12px;

  .modal-content {
    //height: 500px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: top;
    border-radius: 8px;
    //align-items: center;
    //300px
    width: 700px;
    //height: auto;
    padding: 20px 15px;
    //background-color: rgb(171, 235, 24);
    background-color: #fff;
    //margin-right: 50px;

    .header {
      flex-basis: 20%;
      margin-bottom: 20px;
      h1 {
        font-size: 20px;

        @media (min-width: 800px) {
          font-size: 32px;
        }
      }

      h3 {
        font-size: 15px;

        @media (min-width: 800px) {
          font-size: 20px;
        }
      }
    }

    .order {
      flex-basis: 60%;
      //display: flex;
      //justify-content: center;
      background-color: grey;
      border-radius: 8px;
      padding: 5px 12px;

      h6 {
        margin-top: 5px;
        color: #fff;
        margin-bottom: 0;
        font-size: 20px;
      }

      p {
        color: #fff;
        font-size: 18px;
        text-align: left;
      }

      table td {
        text-align: center;
      }
    }

    .selection {
      flex-basis: 20%;
      position: relative;
      //bottom: 20px;
      display: flex;
      padding: 10px;
      justify-content: space-around;
      //margin: 10px;
      gap: 40px;

      .close-button {
        min-width: 120px;

        &:hover {
          background-color: rgb(50, 50, 50);
          transition: 0.25s;
        }
      }

      .accept-button {
        background-color: #30ce30;
        border: 2px solid #30ce30;
        min-width: 120px;

        &:hover {
          background-color: #62f062;
          transition: 0.25s;
        }
      }
    }

    p {
      text-align: center;
      font-size: 40px;
      font-weight: 400;
    }

    button {
      align-self: center;
    }
  }
}
</style>
